export const CHECKBOX_SIZE = {
  xs: '20px',
  md: '22px',
  lg: '24px',
  xl: '28px'
};
export const CHECKBOX_LABEL_MARGIN = {
  xs: '6px',
  md: '8px',
  xl: '10px'
};